let animationFrameIds = [];

const RESTART_EVENT = 'countdown:restart'; 

function initializeDailyCountdown() {
    animationFrameIds.forEach(cancelAnimationFrame);
    animationFrameIds = [];

    const wrappers = document.querySelectorAll(".countdown-wrapper-daily");

    if (wrappers.length === 0) {
        return;
    }

    const addZero = (x) => (x < 10 && x >= 0 ? "0" + x : x);

    const getHostSuffix = () => {
        const host = window.location.host;
        if (host.includes(".au")) return "au";
        if (host.includes(".nz")) return "nz";
        return "default";
    };

    const updateSingleCountdown = (wrapper) => {
        const countdown = wrapper.querySelector(".countdown-daily");
        if (!countdown) return;

        const hourElem = countdown.querySelector(".hour");
        const minElem = countdown.querySelector(".min");
        const secElem = countdown.querySelector(".sec");

        if (!hourElem || !minElem || !secElem) return;

        const target = countdown;
        const now = new Date();
        const timeAttr = target.getAttribute("data-time");
        if (!timeAttr) return;

        const [targetHour, targetMin] = timeAttr.split(":").map(Number);
        const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetHour, targetMin, 0, 0).getTime();

        const endCallback = () => {
            const hostType = getHostSuffix();
            if (hostType === "au") {
                wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay | Zip</span>";
            } else if (hostType === "nz") {
                wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay</span>";
            } else {
                wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay</span>";
            }
        };

        const tick = () => {
            const nowTime = new Date().getTime();
            const distance = endTime - nowTime;

            if (distance <= 0) {
                endCallback();
                return;
            }

            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            hourElem.querySelector(".num").textContent = addZero(hours);
            hourElem.querySelector(".word").textContent = "hours";
            minElem.querySelector(".num").textContent = addZero(minutes);
            minElem.querySelector(".word").textContent = "minutes";
            secElem.querySelector(".num").textContent = addZero(seconds);
            secElem.querySelector(".word").textContent = "seconds";

            const id = requestAnimationFrame(tick);
            animationFrameIds.push(id);
        };
        
        const initialId = requestAnimationFrame(tick);
        animationFrameIds.push(initialId);
    };

    wrappers.forEach(updateSingleCountdown);
}

document.addEventListener('DOMContentLoaded', initializeDailyCountdown);

document.addEventListener(RESTART_EVENT, initializeDailyCountdown);